import React, { useEffect } from "react";

export default function SEO({
  title = "GEMS — Group Expense Ledger & Bill Splitter",
  description = "GEMS is a modern group-expense platform for small crews, travel trips, and flatmates. Built on double-entry ledger principles for complete auditability.",
  keywords = "group expense manager, bill splitter, split bills, shared wallet, expense ledger, settle up, trip expenses",
  canonicalUrl = window.location.href,
  ogImage = "https://splitly.app/og-cover.png",
  ogType = "website",
  schemaType = "SoftwareApplication",
  schemaData = null,
  noIndex = false,
}) {
  useEffect(() => {
    // Title
    document.title = title;

    // Helper to update meta tag
    const setMeta = (name, content, attr = "name") => {
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content || "");
    };

    // Standard Meta
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("robots", noIndex ? "noindex, nofollow" : "index, follow");

    // OpenGraph Meta
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", ogType, "property");
    setMeta("og:url", canonicalUrl, "property");
    setMeta("og:image", ogImage, "property");
    setMeta("og:site_name", "GEMS", "property");

    // Twitter Meta
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    // Canonical link
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    // Default JSON-LD Schema
    const defaultSchema = {
      "@context": "https://schema.org",
      "@type": schemaType,
      name: "GEMS",
      applicationCategory: "FinanceApplication",
      operatingSystem: "Web",
      url: "https://splitly.app",
      description: description,
      offers: {
        "@type": "Offer",
        price: "0.00",
        priceCurrency: "USD",
      },
      publisher: {
        "@type": "Organization",
        name: "GEMS Inc.",
        url: "https://splitly.app",
        logo: "https://splitly.app/logo.png",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "Customer Support",
          url: "https://saharey.com/contactus",
        },
      },
    };

    const finalSchema = schemaData ? { ...defaultSchema, ...schemaData } : defaultSchema;

    let script = document.getElementById("json-ld-schema");
    if (!script) {
      script = document.createElement("script");
      script.id = "json-ld-schema";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(finalSchema);
  }, [title, description, keywords, canonicalUrl, ogImage, ogType, schemaType, schemaData, noIndex]);

  return null;
}
